<div class="row justify-content-center" data-testId="hospital-chain-section">
  <div class="col-6">
    <div>
      <h5>{{ localizationKey('hospitalPutHospitalInChainTitle') | localize }}</h5>
    </div>
    <div class="row">

      <label class="col-6">
        {{ localizationKey('hospitalPutHospitalInChainSelect') | localize }}:
      </label>

      <div class="col-6">
        <select
          [ngModel]="selectedChainId"
          (ngModelChange)="onChainSelectionChange($event)"
          [disabled]="settingChainDisabled"
          data-testId="hospital-chain-section-chains-dropdown"
          class="form-select col-sm-auto">
          <option [ngValue]="undefined"></option>
          <option *ngFor="let chain of chains"
                  [ngValue]="chain?.id">{{ chain?.name }}
          </option>
        </select>
      </div>

    </div>
  </div>
</div>
